import React from 'react';
import Lottie from 'react-lottie';
import animationData from 'assets/animations/loader';
import { Box, Typography } from '@mui/material';
import { useTranslation } from "react-i18next";

const LoaderAnimation = () => {
  const { t } = useTranslation();
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      };
    
    return (
      <Box sx={{display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", height: "70vh"}}>
        <Lottie 
          options={defaultOptions}
          height={200}
          width={200}
        />
        <Typography variant='h5'>{t("loadingMessages")}</Typography>
      </Box>
    );
}

export default LoaderAnimation;